module.exports = ".content-wrapper {\n  padding-top: 40px;\n}"